import React from 'react';
import {
  CCard,
  CCardBody,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CButton,
} from '@coreui/react';
import { FaDownload } from 'react-icons/fa';
import userApi from 'src/utils/axios';
import { saveAs } from 'file-saver';
import ConfigData from '../../../config/constant.json';


const EnrolledStudents = ({ studentData, onBack, courseName, batchName}) => {

  const handleDownloadCertificate = async (student) => {
    
    try {
      const response = await userApi.get(
        `${ConfigData.SERVER_URL}/admin/course/generateCourseCertificate`,
        {
          params: {
            userId: student.userId,
            batchId: student.batchId,
          },
          responseType: 'blob',
        }
      );
      const filename = `${student?.userDetails?.fullName ? student?.userDetails?.fullName :`${student?.userDetails?.firstName} ${student?.userDetails?.lastName}` }_certificate.pdf`;
      saveAs(new Blob([response.data]), filename);
    } catch (error) {
      console.error('Error generating certificate:', error);
    }
  };

  return (
    <CCard>
       
      <CCardBody>
      <CButton className="mt-3" color="secondary" onClick={onBack}>
          Back to Courses
        </CButton>
        <h5>
          Students Enrolled in :- {courseName} - {batchName}
        </h5>
        <CTable hover responsive>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell>Student Name</CTableHeaderCell>
              <CTableHeaderCell>Enrollment Date</CTableHeaderCell>
              <CTableHeaderCell>Status</CTableHeaderCell>
              <CTableHeaderCell>Action</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {studentData?.map((student, idx) => (
              <CTableRow key={idx}>
                <CTableDataCell>{student.userDetails?.fullName}</CTableDataCell>
                <CTableDataCell>
                  {student.createdAt
                    ? new Date(student.createdAt).toLocaleDateString()
                    : 'N/A'}
                </CTableDataCell>
                <CTableDataCell>{student.status || 'N/A'}</CTableDataCell>
                <CTableDataCell>
                  <CButton
                    size="sm"
                    color="success"
                    onClick={() => handleDownloadCertificate(student)}
                  >
                    <FaDownload className="me-1" />
                 
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      
      </CCardBody>
    </CCard>
  );
};


export default EnrolledStudents;
